var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyIcon = function SvgEmptyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 68,
    viewBox: "0 0 192 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 168,
    height: 20,
    rx: 4,
    fill: "#9D62CC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 95,
    height: 15,
    rx: 3.5,
    fill: "white",
    stroke: "#E1E8F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 80,
    height: 4,
    rx: 2,
    fill: "#D3D7DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 48,
    width: 168,
    height: 20,
    rx: 4,
    fill: "#D05E8E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 40.5,
    width: 95,
    height: 15,
    rx: 3.5,
    fill: "white",
    stroke: "#E1E8F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 46,
    width: 80,
    height: 4,
    rx: 2,
    fill: "#D3D7DF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-icon.0514cdd0.svg";
export { ForwardRef as ReactComponent };